import {breakpointDown, breakpointUp, getScreenHeight, pxToScreenSize} from '../utils/breakpoints'
import {gsap} from 'gsap'
import {elementsToMaxHeight} from '../utils/elements-to-max-sizes'
import {Swiper} from 'swiper'
import {FreeMode, Navigation} from 'swiper/modules'
import {ScrollTrigger} from "gsap/ScrollTrigger";

let ourTeamSwiper;

function init() {
  const swiperElement = document.querySelector('.swiper-our-team')
  if (!swiperElement) return false

  const clearSwiper = () => {
    if (ourTeamSwiper) {
      ourTeamSwiper.destroy(true, true); // Destroy Swiper instance
      ourTeamSwiper = null; // Set swiper to null
    }
    $(`${ourTeamSwiper} .swiper-slide`).removeAttr('style');
  }
  clearSwiper();
  if ($(window).width() > 991) return false

  elementsToMaxHeight($('.swiper-our-team .card-description'))
  elementsToMaxHeight($('.swiper-our-team .card-footer'))

  ourTeamSwiper = new Swiper('.swiper-our-team', {
    modules: [FreeMode, Navigation], spaceBetween: 0, slidesPerView: 'auto', freeMode: {
      enabled: true
    }, navigation: {
      nextEl: ".swiper-our-team-next", prevEl: ".swiper-our-team-prev",
    }, loop: true,
  })
}

let ourTeamSlider;

function initVerticalSlider() {
  let block = document.querySelector('.block-our-team')

  if (!block) return false
  const clearVerticalSlider = () => {
    if (ourTeamSlider) {
      ScrollTrigger.getById('our-team-slider').kill(true);
      ourTeamSlider.kill(true);
      ourTeamSlider = null;
    }
  }
  clearVerticalSlider();
  if ($(window).width() < 992) return false

  let header = block.querySelector('.block-header .h1-larger')
  let cards = block.querySelectorAll('.vertical-slide')

  let headerHeight = header.clientHeight

  let underTitle = (headerHeight / 2) + (getScreenHeight() / 2)


  for (let i = 0; i < cards.length; i++) {
    let marginIndex = i % 3;
    let marginTop;

    switch (marginIndex) {
      case 0:
        marginTop = pxToScreenSize(116);
        break;
      case 1:
        marginTop = underTitle + pxToScreenSize(92);
        break;
      case 2:
        marginTop = underTitle - headerHeight;
        break;
      default:
        marginTop = 0;
    }

    cards[i].style.marginTop = `${marginTop}px`;
  }

  let cardsHeight = block.querySelector('.vertical-slides').clientHeight
  let linkCardHeight = cards[cards.length - 1].clientHeight
  let scrollUpLimit = cardsHeight - (getScreenHeight() / 2) - (linkCardHeight / 2)

  ourTeamSlider = gsap.timeline({
    scrollTrigger: {
      id: 'our-team-slider', trigger: block, pin: true, start: 'center center', end: '+=120%', // markers: true,
      scrub: true,
    }
  })

  const verticalSlides = block.querySelector('.vertical-slides')

  ourTeamSlider.fromTo(verticalSlides, {y: 0}, {y: -scrollUpLimit})

}

window.initOurTeamBlock = () => {
  init()
  initVerticalSlider()
}
initOurTeamBlock();
